import { toastError } from "../../../Helpers/toasts";
import StudentAcquisitionRepositoty from "../../../Repositories/GroupManagement/StudentAcquisitionRepository";
import { useStudentAcquisitionStore } from "../../../Store/GroupManagement/StudentAcquisitionStore";

export const onReload = async () => {
  useStudentAcquisitionStore.setState({
    age_groups: null,
    months: null,
    total_counts: null,
    years: null,
    queryYear: null,
    queryMonth: null,
  });
  const { data, status, nonFieldErrors } =
    await StudentAcquisitionRepositoty.getGroups();

  if (status) {
    useStudentAcquisitionStore.setState({
      age_groups: data.age_groups,
      months: data.months,
      total_counts: data.total_counts,
      years: data.years,
    });
  }
  toastError(nonFieldErrors);
};
export const loadItems = async (queryString) => {
  useStudentAcquisitionStore.setState({
    age_groups: null,
    months: null,
    total_counts: null,
    years: null,
  });
  const { data, status, nonFieldErrors } =
    await StudentAcquisitionRepositoty.getGroups(queryString);
  if (status) {
    useStudentAcquisitionStore.setState({
      age_groups: data.age_groups,
      months: data.months,
      total_counts: data.total_counts,
      years: data.years,
    });
  }
  toastError(nonFieldErrors);
};
